import { StoreData } from 'store/root-reducer';

export const selectSelectedBrands = (state: StoreData) => state.filterMenu.selected.brands;
export const selectSelectedCategories = (state: StoreData) => ({
  id: state.filterMenu.selected.category,
  parentId: state.filterMenu.selected.parentcategory,
});
